{
    "5cxaIPXCKo-tJq_FW5T91": {
        "key": "5cxaIPXCKo-tJq_FW5T91",
        "position": {
            "x": 5,
            "y": 1,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker"
    },
    "thgNJQ0JEvcz_5GvTvWJg": {
        "key": "thgNJQ0JEvcz_5GvTvWJg",
        "position": {
            "x": 5,
            "y": 4,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/archer"
    },
    "nViia5w2STj-7jgYCoFV1": {
        "key": "nViia5w2STj-7jgYCoFV1",
        "position": {
            "x": 2,
            "y": 0,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/archer"
    },
    "JGqP8wqaU1ex5hgI9mO9N": {
        "key": "JGqP8wqaU1ex5hgI9mO9N",
        "position": {
            "x": 0,
            "y": 3,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker"
    }
}